import React from 'react'
import PropTypes from 'prop-types'
import './LoginView.scss'

import {DFS, getLanguageScope} from '../../../helpers'

const _i18n = getLanguageScope('login');

import InputMask from 'react-input-mask';
import MAYA from '../../../maya_api'

import {Button, Form, Grid, Image, Segment, Message, Icon, Dropdown, Header, Label, Checkbox} from 'semantic-ui-react'
import MayaLogoImage from '../../../assets/maya_pink_logo.png'
import {
  tryToInitDevice, changePhoneNumber, changePassword, setSelectedDevice, resetDevices,
  switchAccountMode, setError, setLoading, changeAccount, setDevices
} from '../services/login'
import {LOGIN_ERROR_CODES} from "../../../constants";
import {markAsAuthenticated} from "../modules/login";

class LoginView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      phone_number: MAYA.getPhoneNumber() || '',
      accounts: MAYA.getAccounts() || [],
      showNewClerk: false,
      password: '',
      devices: [],
      selectedDevice: '',
      loading: false,
      error: null
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangePhoneNumber = this.handleChangePhoneNumber.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.switchAccountMode = this.switchAccountMode.bind(this);
    this.handleChangeAccount = this.handleChangeAccount.bind(this);
  }

  handleChangePhoneNumber(e) {
    this.setState(changePhoneNumber(e.currentTarget.value))
  }

  handleChangePassword(e, {name, value}) {
    this.setState(changePassword(value))
  }

  switchAccountMode() {
    this.setState(switchAccountMode())
  }

  handleChangeAccount(e, {name, value}) {
    this.setState(changeAccount(value))
  }

  async handleSubmit() {
    const {phone_number, password, selectedDevice} = this.state;
    const {markAsAuthenticated} = this.props;

    if (!(phone_number && phone_number.length === 11)) {
      return this.setState(setError('error', _i18n('phone_number_invalid_title'), _i18n('phone_number_invalid_message')))
    }

    if (!password) {
      return this.setState(setError('error', _i18n('password_invalid_title'), _i18n('password_invalid_message')))
    }

    this.setState(setLoading(true));

    const result = await tryToInitDevice(phone_number, password, selectedDevice);

    if (!result) {
      return this.setState(setError('error', _i18n('unexpected_error_title'), _i18n('unexpected_error_message')))
    }

    if (result.error_code === LOGIN_ERROR_CODES.DEVICE_NOT_FOUND) {
      return this.setState(setError('warning', _i18n('device_not_found_title'), _i18n('device_not_found_message')))
    }

    if (result.devices && result.devices.length) {
      return this.setState(setDevices(result.devices));
    }

    if (result.error_code === LOGIN_ERROR_CODES.USER_NOT_FOUND) {
      return this.setState(setError('warning', _i18n('user_not_found_title'), _i18n('user_not_found_message')))
    }

    if (result.error_code === LOGIN_ERROR_CODES.ACCESS_DENIED) {
      return this.setState(setError('error', _i18n('access_denied_title'), _i18n('access_denied_message')))
    }

    if (result.error_code === LOGIN_ERROR_CODES.INVALID_GRANT) {
      return this.setState(setError('error', _i18n('invalid_grant_title'), _i18n('invalid_grant_message')))
    }

    if (result.error_code === LOGIN_ERROR_CODES.SSO_ERROR) {
      return this.setState(setError('error', _i18n('sso_error_title'), _i18n('sso_error_message')))
    }

    if (result.error_code === LOGIN_ERROR_CODES.UNEXPECTED_ERROR) {
      return this.setState(setError('error', _i18n('unexpected_error_title'), _i18n('unexpected_error_message')))
    }

    this.setState(setLoading(false));

    markAsAuthenticated(true);
  };

  getLanguageScope(scope) {
    return function (key) {
      return _i18n(`${scope}.${key}`)
    }
  }

  renderError() {
    const {error} = this.state;
    if (!error) return null;

    return <Message visible {...error}/>;
  }

  renderAccounts() {
    const {accounts, phone_number, showNewClerk} = this.state;

    if (showNewClerk || !(accounts && accounts.length)) {
      return (
        <Form.Input fluid iconPosition='left'>
          <Icon name='phone'/>
          <InputMask value={phone_number}
                     onChange={this.handleChangePhoneNumber} placeholder={_i18n('phone_number')}
                     mask="+1\ (999) 999-9999" maskChar="_"/>

        </Form.Input>
      )
    }

    return (
      <Form.Input fluid>
        <Dropdown defaultValue={phone_number} onChange={this.handleChangeAccount}
                  fluid selection options={accounts}/>
      </Form.Input>
    )
  }

  renderLoginForm() {
    const {password, accounts, showNewClerk, loading} = this.state;

    return (
      <Form loading={loading} onSubmit={this.handleSubmit} size='large'>
        <Segment stacked>

          {this.renderAccounts()}

          <Form.Input
            name='password'
            value={password}
            onChange={this.handleChangePassword}
            fluid
            icon='lock'
            iconPosition='left'
            placeholder={_i18n('password')}
            type='password'
          />

          {this.renderError()}

          <Button color='violet' fluid size='large'>
            {_i18n('login')}
          </Button>

          {accounts && accounts.length ?
            <Header as='p' className='button-add-clerk' onClick={this.switchAccountMode}>{
              showNewClerk ? _i18n('select_clerk') : _i18n('add_new_clerk')
            }</Header> : null}

        </Segment>
      </Form>
    )
  }

  renderDevices() {
    const {loading, selectedDevice, devices} = this.state;

    return (
      <Form loading={loading} size='large'>
        <Segment stacked>

          <Label onClick={() => this.setState(resetDevices())} as={'a'} attached='top left'>{_i18n('back_to_login')}</Label>

          <Form.Field style={{textAlign: 'left'}} >
            <Header as={'h4'} content={`${_i18n('select_device')}:`}/>
          </Form.Field>

          {_.map(devices, (d, key) => {
            return (
              <Form.Field style={{textAlign: 'left'}} key={key}>
                <Checkbox
                  radio
                  label={d.info}
                  name='deviceRadioGroup'
                  value={d.device_guid}
                  checked={selectedDevice === d.device_guid}
                  onChange={() => this.setState(setSelectedDevice(d.device_guid))}
                />
              </Form.Field>
            )
          })}

          {this.renderError()}

          <Form.Field>
            <Button color='violet' fluid labelPosition='right' disabled={!selectedDevice} icon='right chevron' onClick={this.handleSubmit} content={_i18n('submit')} />
          </Form.Field>

        </Segment>
      </Form>
    )
  }

  render() {
    const {devices} = this.state;

    return (
      <div className='login-form'>
        <Grid textAlign='center' className={'form-login-wrapper'} style={{height: '100%'}} verticalAlign='middle'>
          <Grid.Column className={'form-login-col'}>
            <Image size='medium' style={{paddingBottom: 20}} centered src={MayaLogoImage}/>
            {!(devices && devices.length) ? this.renderLoginForm() : this.renderDevices()}
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}

LoginView.propTypes = {
  phone_number: PropTypes.string,
  password: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.object,
};

export default LoginView



// WEBPACK FOOTER //
// ./src/routes/Login/components/LoginView.js